/**
 * Normalise la config partenaire (n8n ou fallback statique).
 * Garantit que tous les flags de pricing/affichage existent avec des valeurs saines.
 */
export function normalizeConfig(config) {
  if (!config) return {};
  const id = config.id;

  const deliveryCost =
    config.deliveryCost != null && !Number.isNaN(Number(config.deliveryCost))
      ? Number(config.deliveryCost)
      : 0;

  const deliveryFreeThreshold =
    config.deliveryFreeThreshold != null &&
    !Number.isNaN(Number(config.deliveryFreeThreshold))
      ? Number(config.deliveryFreeThreshold)
      : -1;

  const applyPartnerDiscount =
    config.applyPartnerDiscount !== undefined
      ? Boolean(config.applyPartnerDiscount)
      : id === "version1";

  const applyDeliveryFee =
    config.applyDeliveryFee !== undefined
      ? Boolean(config.applyDeliveryFee)
      : true;

  let showPartnerDiscountInSummary = config.showPartnerDiscountInSummary;
  if (showPartnerDiscountInSummary === undefined) {
    showPartnerDiscountInSummary = applyPartnerDiscount;
  } else {
    showPartnerDiscountInSummary = Boolean(showPartnerDiscountInSummary);
  }

  let showDeliveryFeeInSummary = config.showDeliveryFeeInSummary;
  if (showDeliveryFeeInSummary === undefined) {
    showDeliveryFeeInSummary = applyDeliveryFee && deliveryCost > 0;
  } else {
    showDeliveryFeeInSummary = Boolean(showDeliveryFeeInSummary);
  }

  return {
    ...config,
    deliveryCost,
    deliveryFreeThreshold,
    applyPartnerDiscount,
    applyDeliveryFee,
    showPartnerDiscountInSummary,
    showDeliveryFeeInSummary,
  };
}
